<template>
  <transition name="modal">
    <div class="modal-mask">
      <a
        class="modal-close"
        aria-label="Close"
        @click="$emit('close')"
      >
        <img
          :src="asset('/images/close.png')"
          width="35px"
        > </a>

      <div class="modal-wrapper">
        <div class="modal-container large">
          <div class="modal-header">
            <h4 class="modal-title">
              Terms and Conditions
            </h4>
          </div>

          <div class="modal-body scrollable">
            <p v-html="text" />
          </div>

          <div class="modal-footer full-width">
            <div class="col-md-6" />
            <div class="col-md-6">
              <button
                type="button"
                class="btn btn-danger btn-lg btn-block"
                @click="$emit('close')"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TermsAndConditions',
  computed: {
    text () {
      if (this.$store.state.terms !== null) {
        return this.$store.state.terms
      }
      return 'T & C'
    }
  },
  created () {

  }
}
</script>
